import React from "react";
import {
  Container,
  Paper,
  Grid,
  Checkbox,
  TextField,
  RadioGroup,
} from "@material-ui/core";
import Joi from "@hapi/joi";
import { withSnackbar } from "notistack";
import Form from "../../../common/form";
import Loading from "../../../common/loading";
import TitleComponent from "../../../common/titleComponent";
import Breadcrumb from "../../../common/breadcum";
import { getComponentActivities } from "../../../../services/componentActivitiesService";
import {
  getRequirement,
  saveRequirement,
} from "../../../../services/requirementService";
import { typesIva, typesRequirements } from "../../../../utils/constants";
import { Autocomplete } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import maths from "../../../../utils/maths";
class EditRequirementForm extends Form {
  state = {
    data: {
      type: typesRequirements.BIEN,
      name: "",
      quantity: "",
      code_cpc: "",
      cuatrimestre1: "",
      porcentajec1: "",
      cuatrimestre2: "",
      porcentajec2: "",
      cuatrimestre3: "",
      porcentajec3: "",
      price: "0.00",
      iva: "",
      ivas: "",
      total_price: "0.00",
      activity_id: { id: "", name: "" },
      activity: { component: { project: "" } },
    },
    componentActivities: [],
    errors: {},
    isLoading: false,
  };

  schema = Joi.object({
    id: Joi.number().integer(),
    type: Joi.string().label("Tipo compra"),
    name: Joi.string().label("Nombre"),
    quantity: Joi.number().positive().integer().label("Cantidad"),
    code_cpc: Joi.string().label("Código CPC"),
    cuatrimestre1: Joi.string().label("Cuatrimestre I "),
    porcentajec1: Joi.number().precision(2).label("Porcentaje Cuatrimestre I"),
    cuatrimestre2: Joi.string().label("Cuatrimestre II"),
    porcentajec2: Joi.number().precision(2).label("Porcentaje Cuatrimestre II"),
    cuatrimestre3: Joi.string().label("Cuatrimestre III"),
    porcentajec3: Joi.number()
      .precision(2)
      .label("Porcentaje Cuatrimestre III"),
    price: Joi.number().precision(2).label("Precio"),
    iva: Joi.number().precision(2).label("IVA "),
    total_price: Joi.number().precision(2).label("Precio total"),
    activity_id: Joi.object().label("Actividad"),
    activity: Joi.object().label("Actividad"),
  });

  types = [
    typesRequirements.BIEN,
    typesRequirements.OBRA,
    typesRequirements.SERVICIO,
    typesRequirements.CONSULTORIA,
  ];

  // typesI = [typesIva.DOCE, typesIva.CERO];
  typesI = [
    { id: 0, name: typesIva.CERO },
    { id: 12, name: typesIva.DOCE },
  ];

  async populateComponentActivities() {
    const comp = this.props.match.params.comp;
    const { data: componentActivities } = await getComponentActivities(comp);
    this.setState({ componentActivities });
  }

  async populateRequirement() {
    try {
      const requirementId = this.props.match.params.id; //Pasando por URL id movie
      if (requirementId === "new") return; //Si si
      const { data: requirement } = await getRequirement(requirementId); //Si no.
      this.setState({ data: this.mapToViewModel(requirement) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  doSubmit = async () => {
    try {
      this.setState({ isLoading: true });
      await saveRequirement(this.state.data);
      this.successMessage();
      // this.props.history.goBack();
    } catch (ex) {
      // this.errorMessage(ex);
      const errors = { ...this.state.errors };
      if (ex.response && ex.response.status === 422) {
        errors.code = ex.response.data.errors.code;
        errors.name = ex.response.data.errors.name;
        errors.acronym = ex.response.data.errors.acronym;
        this.setState({ errors });
      }
      //console.log(ex.response.data.errors);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  getActivity = (activityId) => {
    const activities = [...this.state.componentActivities];
    const act = activities.find((act) => act.id === activityId);
    return { id: act.id, name: act.name };
  };

  handleChangeSelect = (event, newValue, nameSelect) => {
    const data = { ...this.state.data };
    nameSelect !== "type"
      ? (data[nameSelect] = this.getActivity(newValue.id))
      : (data[nameSelect] = newValue);
    this.setState((prevState) => ({ ...prevState, data }));
  };

  handleChangeSelectIva = (event, newValue, nameSelect) => {
    const data = { ...this.state.data };
    nameSelect !== "iva"
      ? (data[nameSelect] = newValue.id)
      : (data[nameSelect] = newValue.name);
    this.setState((prevState) => ({ ...prevState, data }));
    const total = data["quantity"] * data["price"];

    if (data[nameSelect] === "IVA 12%") {
      data["total_price"] = maths.round(total * 0.12 + total);
      data[nameSelect] = 12;
    } else {
      data["total_price"] = maths.round(total);
      data[nameSelect] = 0;
    }
  };
  handleChangeSelectReq = (event, newValue, nameSelect) => {
    const data = { ...this.state.data };
    nameSelect !== "statuses"
      ? (data[nameSelect] = this.getActivity(newValue.id))
      : (data[nameSelect] = newValue);
    this.setState((prevState) => ({ ...prevState, data }));
  };

  icon = (<CheckBoxOutlineBlankIcon fontSize="small" />);
  checkedIcon = (<CheckBoxIcon fontSize="small" />);

  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.populateRequirement();
    await this.populateComponentActivities();
    this.setState({ isLoading: false });
  }

  mapToViewModel(requirement) {
    return {
      id: requirement.id,
      type: requirement.type,
      name: requirement.name,
      quantity: requirement.quantity,
      code_cpc: requirement.code_cpc,
      cuatrimestre1: requirement.cuatrimestre1,
      porcentajec1: requirement.porcentajec1,
      cuatrimestre2: requirement.cuatrimestre2,
      porcentajec2: requirement.porcentajec2,
      cuatrimestre3: requirement.cuatrimestre3,
      porcentajec3: requirement.porcentajec3,
      price: requirement.price,
      iva: requirement.iva,
      total_price: requirement.total_price,
      activity_id: {
        id: requirement.activity.id,
        name: requirement.activity.name,
      },
      activity: requirement.activity,
    };
  }

  /*componentDidUpdate(prevProps, prevState, snapshot) {
    const data = { ...this.state.data };
    /*const total = this.state.data.quantity * data.price;
    if (data.iva === "0") {
      data.total_price = maths.round(total);
      this.setState({ data });
    } else {
      data.total_price = maths.round(total * 0.12 + total);
      this.setState({ data });
    }*/

  /*if (this.state.data.quantity !== prevState.data.quantity) {
      const data = { ...this.state.data };
      data.total_price = maths.round(this.state.data.quantity * data.price);
      this.setState({ data });
    }
    if (this.state.data.price !== prevState.data.price) {
      const data = { ...this.state.data };
      data.total_price = this.state.data.quantity * data.price;
      this.setState({ data });
    }
  }*/

  render() {
    const { isLoading, data, componentActivities } = this.state;
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const listBreadcrumbs = [
      {
        path: "/proyectos",
        label: "Proyectos",
      },
      {
        path: "/proyecto/" + data.activity.component.project.slug,
        label: data.activity.component.project.slug,
      },
    ];

    return (
      <Container maxWidth="md">
        <Loading open={isLoading} />
        <Breadcrumb
          onListBreadcrumbs={listBreadcrumbs}
          lastLabel={"Editar requerimiento"}
        />
        <Grid container spacing={1}>
          <Grid item xs={10} sm={10} md={10}>
            <Paper className="paper">
              <TitleComponent entity={"Editar requerimiento"} />
              <form onSubmit={this.handleSubmit}>
                <Autocomplete
                  id={"type"}
                  name={"type"}
                  limitTags={2}
                  options={this.types}
                  disableClearable
                  getOptionLabel={(type) => type}
                  onChange={(event, values) =>
                    this.handleChangeSelect(event, values, "type")
                  }
                  label={"Tipo Compra *"}
                  value={data.type}
                  renderOption={(option, { selected, inputValue }) => {
                    //console.log("inputvalue:" + selected + "; " + inputValue);
                    return (
                      <React.Fragment>
                        <Checkbox
                          name={"type"}
                          icon={this.icon}
                          checkedIcon={this.checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option}
                      </React.Fragment>
                    );
                  }}
                  getOptionSelected={(option, value) => {
                    return option === value;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      //error={validation}
                      margin="normal"
                      variant="outlined"
                      label={"Tipo compra *"}
                      size="small"
                      placeholder="Tipo de compra a la que pertenece"
                      fullWidth
                    />
                  )}
                />
                {this.renderInput("name", "Nombre")}
                {this.renderInput("code_cpc", "Código CPC")}
                {this.renderInput(
                  "cuatrimestre1",
                  "Cuatrimestre I (Ingrese I)"
                )}
                {this.renderInput("porcentajec1", "Porcentaje Cuatrimestre I")}
                {this.renderInput(
                  "cuatrimestre2",
                  "Cuatrimestre II (Ingrese II)"
                )}
                {this.renderInput("porcentajec2", "Porcentaje Cuatrimestre II")}
                {this.renderInput(
                  "cuatrimestre3",
                  "Cuatrimestre III (Ingrese III)"
                )}
                {this.renderInput(
                  "porcentajec3",
                  "Porcentaje Cuatrimestre III"
                )}
                {this.renderInput("quantity", "Cantidad")}
                {this.renderInput("price", "Precio USD")}

                <Autocomplete
                  id={"iva"}
                  name={"iva"}
                  limitTags={1}
                  options={this.typesI}
                  disableClearable
                  getOptionLabel={(iva) => iva.name}
                  onChange={(event, values) =>
                    this.handleChangeSelectIva(event, values, "iva")
                  }
                  label={"IVA *"}
                  renderOption={(option, { selected, inputValue }) => {
                    //console.log("inputvalue:" + selected + "; " + inputValue);
                    return (
                      <React.Fragment>
                        <RadioGroup
                          name={"iva"}
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </React.Fragment>
                    );
                  }}
                  getOptionSelected={(option, value) => {
                    return option.id === value.id;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      //error={validation}
                      margin="normal"
                      variant="outlined"
                      label={"IVA *"}
                      size="small"
                      placeholder="Tipo de IVA "
                      fullWidth
                    />
                  )}
                />

                {this.renderInput(
                  "total_price",
                  "Precio total USD",
                  "text",
                  true
                )}

                <Autocomplete
                  id={"activity_id"}
                  name={"activity_id"}
                  options={componentActivities}
                  disableClearable
                  getOptionLabel={(activity) => activity.name}
                  onChange={(event, values) =>
                    this.handleChangeSelect(event, values, "activity_id")
                  }
                  value={this.state.data.activity_id}
                  label={"Actividad *"}
                  renderOption={(option, { selected, inputValue }) => {
                    return (
                      <React.Fragment>
                        <Checkbox
                          name={"activity"}
                          icon={this.icon}
                          checkedIcon={this.checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </React.Fragment>
                    );
                  }}
                  getOptionSelected={(option, value) => {
                    return option.name === value.name;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      //error={validation}
                      margin="normal"
                      variant="outlined"
                      label={"Actividad *"}
                      size="small"
                      placeholder="Actividad a la que pertenece"
                      fullWidth
                    />
                  )}
                />
                {this.renderButton("Guardar")}
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default withSnackbar(EditRequirementForm);
